function smooth(float) {
  float *= 1000;
  float = Math.round(float);
  if (float === 0) return "<0.1";
  if (float === 1000) return ">99.9";
  return (float / 10).toFixed(1);
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function rgbToHex(r, g, b) {
  return (
    "#" +
    componentToHex(Math.round(r)) +
    componentToHex(Math.round(g)) +
    componentToHex(Math.round(b))
  );
}
function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}
function bgColor(float) {
  const color = [
    hexToRgb("#eeeeee"),
    hexToRgb("#eee560"),
    hexToRgb("#eea32f"),
    hexToRgb("#ee5e2f"),
  ];
  if (float === "<0.1") return "#eeeeee";
  if (float === ">99.9") return "#ee5e2f";
  if (float < 33) {
    float /= 33;
    return rgbToHex(
      color[0].r,
      (1 - float) * color[0].g + float * color[1].g,
      (1 - float) * color[0].b + float * color[1].b
    );
  }
  if (float < 66) {
    float -= 33;
    float /= 33;
    return rgbToHex(
      color[0].r,
      (1 - float) * color[1].g + float * color[2].g,
      (1 - float) * color[1].b + float * color[2].b
    );
  }
  float -= 66;
  float /= 34;
  return rgbToHex(
    color[0].r,
    (1 - float) * color[2].g + float * color[3].g,
    (1 - float) * color[2].b + float * color[3].b
  );
}
function litColor(float) {
  if (float === "<0.1") return "#7f7f7f";
  return "#000000";
}

export { smooth, bgColor, litColor };
